import PageView from './PageView';

import controlLogo from '../../../../../images/cc/connectwise_control_black_logo.png';

export default {
    name: 'connectwisecontrol',
    label: 'ConnectWise Control',
    enabled: true,
    visible: true,
    alwaysVisible: true,
    logo: controlLogo,
    components: {
        PageView,
    },
    dummy: true,
};
